import angular from 'angular';
import uiRouter from 'angular-ui-router';
import usersComponent from './users.component';
import dataTable from 'angular-material-data-table';

let usersModule = angular.module('users', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('users', {
        url: '/users',
        component: 'users',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('users', usersComponent)
.name;

export default usersModule;
